import { ADialogDispatcher } from 'core_a-dialog';


export default ({ app, store }, inject) => {
  inject('dialog', {
    show(props) {
      if (props.type === 'alert') {
        props.type = 'warning';
        console.warn('The dialog type "alert" has been deprecated. Use "warning" instead.');
      }
      ADialogDispatcher.show(props);
    },
    hide() {
      ADialogDispatcher.hide();
    }
  });
};
